import { ActionIcon, Group, Text } from '@mantine/core';
import { IconAlertCircle, IconCircleCheck } from '@tabler/icons-react';

type MandatoryFieldProps = {
  isChecked: boolean;
};

export const MandatoryField = ({
  isChecked,
  children,
}: React.PropsWithChildren<MandatoryFieldProps>) => (
  <Group gap={4} style={{ userSelect: 'none' }}>
    <ActionIcon
      variant="transparent"
      c={isChecked ? 'green' : 'orange'}
      style={{ pointerEvents: 'none', transition: 'color 0.3s' }}
    >
      {isChecked ? <IconCircleCheck /> : <IconAlertCircle />}
    </ActionIcon>
    <Text style={{ transition: 'color 0.3s' }} c={isChecked ? 'green.7' : 'orange.7'}>
      {children}
    </Text>
  </Group>
);
